function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import LanguagePickerComponent from "/components/core/language-picker/language-picker-component";
import { IMPRESSUM_LINK, MONDAY_LOGO_SRC, PRIVACY_POLICY_LINK, ROOT_LINK, SocialFooterLinks } from "/constants/links";
import PaletteIconsComponent from "segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/palette-icons-component";
import { updateClusterShortFooterLinks } from "client/services/cluster-config-service/cluster-config-service";
import { DIALOG_DIRECTIONS } from "components/core/language-picker/language-picker-service";
import PictureWithLinkComponent from "components/core/picture-with-link/picture-with-link-component.js";
import ShortFooterLink from "./short-footer-link/short-footer-link";
import { LINKS_DATA_COLUMNS, TITLE_TYPE } from "./short-footer-service";
import { StyledShortFooter } from "./short-footer.scss";
import classnames from "classnames";
import AccessibilityStatementLinkComponent from "components/accessibility/accessibility-statement-link/accessibility-statement-link-component";
import { GERMAN_LOCALE_ID } from "constants/localization";
const TITLE_TYPE_TO_CLASS_NAME = {
    [TITLE_TYPE.MAIN]: "main",
    [TITLE_TYPE.MAIN_CLICKABLE]: "main standalone",
    [TITLE_TYPE.SECONDARY]: "secondary",
    [TITLE_TYPE.LINK]: "item"
};
class ShortFooter extends PureComponent {
    renderLinks() {
        const { localeId, pageClusterConfig, useProductMiniSiteConfig } = this.props;
        const links = LINKS_DATA_COLUMNS;
        if (pageClusterConfig) {
            updateClusterShortFooterLinks(pageClusterConfig, links, {
                useProductMiniSiteConfig
            });
        }
        return links.map((link)=>{
            const { title, type } = link;
            return /*#__PURE__*/ _jsx("div", {
                className: classnames("short-footer-link-component-wrapper", "link-wrapper", {
                    [TITLE_TYPE_TO_CLASS_NAME[type]]: type
                }),
                children: /*#__PURE__*/ _jsx(ShortFooterLink, _object_spread({
                    localeId: localeId
                }, link))
            }, title);
        });
    }
    render() {
        const { translate, localeId } = this.props;
        return /*#__PURE__*/ _jsxs(StyledShortFooter, {
            className: "short-footer-component",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "short-footer-header",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "monday-logo-wrapper",
                            children: /*#__PURE__*/ _jsx(PictureWithLinkComponent, {
                                src: MONDAY_LOGO_SRC,
                                className: "footer-monday-logo-image",
                                href: ROOT_LINK,
                                alt: "monday logo"
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "language-picker-wrapper-component link-wrapper",
                            children: /*#__PURE__*/ _jsx(LanguagePickerComponent, {
                                dialogDirection: DIALOG_DIRECTIONS.ALIGN_BOTTOM
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "short-footer-links",
                    children: this.renderLinks()
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "bottom",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "contact-info-wrapper",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "all-right-reserved-info",
                                children: [
                                    translate("allRightsReserved"),
                                    " © monday.com"
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "social-proof-wrapper",
                            children: /*#__PURE__*/ _jsx(PaletteIconsComponent, {
                                SocialFooterLinks: SocialFooterLinks
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "terms",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "accessibility-statement-link-wrapper link-wrapper",
                                    children: /*#__PURE__*/ _jsx(AccessibilityStatementLinkComponent, {})
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "footer-link",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: PRIVACY_POLICY_LINK,
                                        children: translate("footer.termsAndPrivacy")
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "footer-link",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        "data-footer-link-type": "cookie-settings",
                                        onClick: ()=>{
                                            var _window_cookiehub, _window;
                                            return (_window = window) === null || _window === void 0 ? void 0 : (_window_cookiehub = _window.cookiehub) === null || _window_cookiehub === void 0 ? void 0 : _window_cookiehub.openSettings();
                                        },
                                        children: translate("footer.yourPrivacyChoices")
                                    })
                                }),
                                localeId === GERMAN_LOCALE_ID && /*#__PURE__*/ _jsx("div", {
                                    className: "footer-link",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: IMPRESSUM_LINK,
                                        children: translate("footer.impressum")
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export default withGenericConfig(ShortFooter);
